import { render, staticRenderFns } from "./smallLoader.vue?vue&type=template&id=50017137&scoped=true"
import script from "./smallLoader.vue?vue&type=script&lang=js"
export * from "./smallLoader.vue?vue&type=script&lang=js"
import style0 from "./smallLoader.vue?vue&type=style&index=0&id=50017137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50017137",
  null
  
)

export default component.exports